module.exports = __webpack_public_path__ + "img/set-up-icon.3876717f.svg";